import React from 'react';

export const preventDefaultMouseEvent = (event: React.MouseEvent) => {
  event.preventDefault();
  return false;
};

export const stopPropagationMouseEvent = (event?: React.MouseEvent) => {
  event?.stopPropagation();
  return false;
};
